import { useMutation } from '@tanstack/react-query';

export default function useUpdatePassworsSetup(id: string) {
  return useMutation({
    mutationFn: async (params: { password: string; password_confirmation: string }) => {
      const response = await fetch(`/account/api/signup/${id}`, {
        method: 'PUT',
        body: JSON.stringify(params),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        throw new Error('Failed to update password setup');
      }
      const updatedData = await response.json();
      return updatedData;
    },
  });
}
